module.exports = __webpack_public_path__ + "static/sabotage-de8c75c0ad56ef3bf65ea5f46fc54b11.jpg";